import { FileDownloader } from '../clients/file-downloader';
import clientFactory from './client-factory';

export default new FileDownloader(clientFactory);
